import { useState, useEffect } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { authApi } from '@/api/auth';

export function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');

  const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');

  useEffect(() => {
    if (!token) {
      setStatus('error');
      return;
    }

    authApi.verifyEmail(token)
      .then(() => setStatus('success'))
      .catch(() => setStatus('error'));
  }, [token]);

  return (
    <div className="min-h-screen bg-mono-950 flex items-center justify-center py-12 px-4">
      <div className="max-w-sm w-full text-center">
        <div className="mb-10">
          <h1 className="text-3xl font-bold text-mono-100 tracking-[0.4em] font-orbitron">ARGOS</h1>
          <p className="text-mono-500 text-xs tracking-widest mt-2 font-orbitron">EMAIL VERIFICATION</p>
          <div className="mt-8 h-px bg-mono-800" />
        </div>

        {status === 'loading' && (
          <div className="border border-mono-700 p-6">
            <p className="text-xs text-mono-400 tracking-wider">VERIFYING...</p>
          </div>
        )}

        {status === 'success' && (
          <div className="space-y-6">
            <div className="border border-green-500/30 bg-green-500/10 p-6">
              <p className="text-xs text-green-400 tracking-wider mb-2">EMAIL VERIFIED</p>
              <p className="text-[11px] text-mono-400 leading-relaxed">
                Your email has been verified successfully.
              </p>
            </div>
            <Link
              to="/login"
              className="inline-block py-3 px-8 border border-cyan-500 bg-cyan-500 text-black text-xs font-medium tracking-widest hover:bg-cyan-400 transition-colors"
            >
              GO TO LOGIN
            </Link>
          </div>
        )}

        {status === 'error' && (
          <div className="space-y-6">
            <div className="border border-red-500/30 bg-red-500/10 p-6">
              <p className="text-xs text-red-400 tracking-wider mb-2">VERIFICATION FAILED</p>
              <p className="text-[11px] text-mono-400 leading-relaxed">
                This verification link is invalid or has expired.
              </p>
            </div>
            <Link
              to="/login"
              className="inline-block text-[10px] text-cyan-400 hover:text-cyan-300 tracking-wider"
            >
              GO TO LOGIN
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
